import "Scss/__index_rent.scss";
import { Carousel } from "Components/carousel";
import { Gallery } from "@/components/gallery";
// import { initSoftTabGallery } from "./soft-tab/gallery";

document.addEventListener("DOMContentLoaded", function () {
  // initSoftTabGallery();
  Gallery.init();
  Carousel.init(".soft-tab-gallery");
});
